export const FAILED_REGENERATION = 'Failed to regenerate Production plan for';
export const REGENERATION_SUCCESS = 'Production plan regenerated for';
